import PropTypes from "prop-types"
import { Checkbox, ListItemText, MenuItem } from "@mui/material"
import { Controller } from "react-hook-form"
import DropdownCommon from "./DropdownCommon"

const DropDownCheck = ({ control, label, name, options, ...rest }) => {
  const toToken = (value) => String(value).replace(/[^a-zA-Z0-9_-]/g, "-")

  const renderOptions = (options, value) => {
    const selectedValues = Array.isArray(value) ? value : []

    return options.map((option) => (
      <MenuItem
        data-field={name}
        data-testid={`${name}-option-${toToken(option.value)}`}
        data-value={option.value}
        key={option.value}
        value={option.value}
      >
        <Checkbox
          checked={selectedValues.includes(option.value)}
          inputProps={{
            'data-field': name,
            'data-testid': `${name}-checkbox-${toToken(option.value)}`,
            'data-value': option.value,
          }}
          size="small"
        />
        <ListItemText primary={option.label} />
      </MenuItem>
    ))
  }

  return (
    <Controller
      control={control}
      label={label}
      name={name}
      render={({
        field: { onChange, value },
        fieldState: { error }
      }) => (
        <DropdownCommon
          {...rest}
          error={error}
          label={label}
          multiple={true}
          name={name}
          onChange={onChange}
          renderOptions={renderOptions(options, value)}
          renderValue={(selected) => Array.isArray(selected) ? selected.join(', ') : selected}
          value={Array.isArray(value) ? value : []}
        />
      )}
    />
  )
}

DropDownCheck.propTypes = {
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired
}

export default DropDownCheck
